import React from 'react';
import { Dot, LoaderComponent, LoaderContainer } from './mixins';
export const Loader = (props) => {
    return (React.createElement(LoaderContainer, Object.assign({}, props),
        React.createElement(LoaderComponent, null,
            React.createElement(Dot, null),
            React.createElement(Dot, null),
            React.createElement(Dot, null),
            React.createElement(Dot, null),
            React.createElement(Dot, null))));
};
export default Loader;
